export default __webpack_public_path__ + "static/media/Komal.04ed2301.jpeg";